import React, { useEffect } from "react";
import NavBarHome from "../components/NavBarHome";
import "../App.css";
import { Helmet } from "react-helmet";

export default function Circle(props) {

  useEffect(() => {
    const email = localStorage.getItem("email")
    if (email == "null" || !email) {
      window.location.href = "/login";
    }
  }, []);
  
  return (
    <>
     <Helmet>
            <title>Fiddle School</title>
            <meta
              name="description"
              content="Learn to play the fiddle with step-by-step video lessons, expert guidance from Katie Glassman, and a supportive online community."
            />
    
            {/* Open Graph */}
            <meta property="og:title" content="Fiddle School" />
            <meta
              property="og:site_name"
              content="Katie Glassman's Fiddle School"
            />
            <meta
              property="og:description"
              content="Learn to play the fiddle with step-by-step video lessons, expert guidance from Katie Glassman, and a supportive online community."
            />
            <meta property="og:type" content="article" />
            <meta
              property="og:image"
              content="https://fiddleschool.com/logo192.png"
            />
            <meta property="og:url" content={window.location.href} />
          </Helmet>
      <div className="screen-container">
        <NavBarHome page={"circle"} />
        <iframe
          title="circle"
          style={{ marginTop: 105 }}
          className="splash-iframe"
          src="https://community.fiddleschool.com"
        />
      </div>
    </>
  );
}
